import fanListStore from '@modules/fan/fan-list-store';
import fanViewStore from '@modules/fan/fan-view-store';
import fanImporterStore from '@modules/fan/fan-importer-store';
import fanFormStore from '@modules/fan/fan-form-store';
import fanDestroyStore from '@modules/fan/fan-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: fanDestroyStore,
    form: fanFormStore,
    list: fanListStore,
    view: fanViewStore,
    importer: fanImporterStore,
  },
};
